import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/(with-layout)/safety/rules/page.tsx");
